import { useAppData } from "providers/RootStoreProvider";
import { HeaderNonLegal } from "./HeaderNonLegal";
import { HeaderLegal } from "./HeaderLegal";
import { useEffect } from "react";
import { themeColors } from "constants/colors.const";
import { observer } from "mobx-react-lite";

export const Header = observer(() => {
    const { flowOuter } = useAppData();

    useEffect(() => {
        const metaThemeTag = document.querySelector("meta[name='theme-color']");
        if (metaThemeTag) {
            const metaThemeColor = flowOuter ? themeColors.text.fullBlack : themeColors.background.primary;
            metaThemeTag.setAttribute("content", metaThemeColor);
        }
    }, [flowOuter]);

    return <>{flowOuter ? <HeaderNonLegal /> : <HeaderLegal />}</>;
});
